import React from 'react';
import './AccordionMenuBody.scss';

const AccordionMenuBody = ({ content }) => {
  return <div className="accordion-menu-body">{content}</div>;
};

export default AccordionMenuBody;
